import { ThemeUICSSObject, spacing } from '@apia/theme';

const tree: ThemeUICSSObject = {
  listStyle: 'none',
  maxHeight: '250px',
  overflow: 'auto',

  ul: {
    listStyle: 'none',
    borderLeft: '1px solid',
    borderColor: 'treeRuler',
    pl: spacing(6),
  },

  '&:not(.tree__child)': {
    m: spacing(0),
    p: spacing(0),
  },

  li: {
    textAlign: 'center',

    '&:focus, &:focus-visible': {
      outline: 'none',

      '& > .tree__leaf__label span': {
        backgroundColor: (theme) =>
          theme.palette.getColor(theme.palette.background.paper, 'selected'),
        color: (theme) =>
          theme.palette.getContrastText(theme.palette.background.paper),
      },
    },

    ul: {
      ml: spacing(6),
    },
  },

  '.tree__leaf__label': {
    display: 'flex',
    gap: spacing(3),
    alignItems: 'center',
    '& > svg': {
      transition: '0.3s transform',
      transform: 'translateX(-5px)',
      flexShrink: 0,
      width: '24px',

      '&.open': {
        transform: 'translateX(-5px) rotate(90deg)',
      },
    },

    span: {
      p: spacing(2),
    },
  },
};

export default tree;
